// extracted by mini-css-extract-plugin
module.exports = {"videoBox":"VideoLightbox_videoBox__XJXw8"};